export enum SignTypeEnum {
  SIMPLE = 'SIMPLE',
  SIGNX = 'SIGNX',
  TOKEN = 'TOKEN',
  TOKEN_TSP = 'TOKEN_TSP',
  TOKEN_LONG = 'TOKEN_LONG',
  GOS_KEY = 'GOS_KEY',
  GOS_KEY_QES = 'GOS_KEY_QES',
}
